import { BaseContainerModel } from '../../base-container.model';
import { bl_applet_audit_trail_RowClass } from '../../../dbschema';

export class AppletAuditTrailContainer extends BaseContainerModel {
  bl_applet_audit_trail: bl_applet_audit_trail_RowClass = new bl_applet_audit_trail_RowClass();
}